import { Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';

import { TableCellDescriptions } from '../../../components/TableCellDescriptions';
import { apiClient } from '../../../graphql/api/apiClient';
import { usegetFunnelAppointmentByUserRoleQuery } from '../../../graphql/api/generated';
import { UserRoleDetailsFragment } from '../../../graphql/hasura/generated';
import { formatPhoneNumber, formatTimestamp, formatUserName } from '../../../utils';
import { FunnelAppointmentStatus } from '../../Property/components/FunnelAppointmentStatus';

export const FunnelAppointmentDescriptions: React.FC<{ userRole: UserRoleDetailsFragment }> = (props) => {
  const { userRoleId, sourcePayload } = props.userRole;
  const funnelAppointmentId = get(sourcePayload, 'funnelAppointmentId');

  const { data, loading } = usegetFunnelAppointmentByUserRoleQuery({
    client: apiClient,
    skip: !funnelAppointmentId,
    variables: { userRoleId },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <Spin />;
  }

  const funnelAppointment = data?.funnelAppointmentByUserRole;

  if (!funnelAppointment) {
    return null;
  }

  const { client } = funnelAppointment;

  return (
    <TableCellDescriptions
      descriptions={{
        'Appointment ID': funnelAppointmentId,
        'Appointment Status': <FunnelAppointmentStatus status={funnelAppointment.status} />,
        'Start Time': formatTimestamp(funnelAppointment.startTime),
        'Prospect Name': formatUserName(client),
        'Phone Number': formatPhoneNumber(client?.phoneNumber),
        Email: client?.email,
      }}
    />
  );
};
